/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleDetail
 */
export interface ScheduleDetail {
    /**
     * 
     * @type {string}
     * @memberof ScheduleDetail
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleDetail
     */
    start?: string;
}

/**
 * Check if a given object implements the ScheduleDetail interface.
 */
export function instanceOfScheduleDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScheduleDetailFromJSON(json: any): ScheduleDetail {
    return ScheduleDetailFromJSONTyped(json, false);
}

export function ScheduleDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'end': !exists(json, 'end') ? undefined : json['end'],
        'start': !exists(json, 'start') ? undefined : json['start'],
    };
}

export function ScheduleDetailToJSON(value?: ScheduleDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'end': value.end,
        'start': value.start,
    };
}

